import {createAction, props} from '@ngrx/store';
import {ProductFaceDefaultPlacement as Entity} from './product-face-default-placement.model';
import {Criteria} from "../app-store.types";
import {IPage, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";

export const load = createAction(
  '[ProductFaceDefaultPlacement] Load Entities',
  props<{ criteria?: Criteria, correlationId?: string }>()
);

export const loadSuccess = createAction(
  '[ProductFaceDefaultPlacement] Load Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const loadFailure = createAction(
  '[ProductFaceDefaultPlacement] Load Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadSingleIfNecessary = createAction(
  '[ProductFaceDefaultPlacement] Load Single Entity if necessary',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingle = createAction(
  '[ProductFaceDefaultPlacement] Load Single Entity',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingleSuccess = createAction(
  '[ProductFaceDefaultPlacement] Load Single Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const loadSingleFailure = createAction(
  '[ProductFaceDefaultPlacement] Load Single Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadPage = createAction(
  '[ProductFaceDefaultPlacement] Load Paginated Entities',
  props<{ page: IPage, criteria?: Criteria, correlationId?: string }>()
);

export const loadPageSuccess = createAction(
  '[ProductFaceDefaultPlacement] Load Paginated Entities Success',
  props<{ resultWithPageInfo: IResultWithPageInfo<Entity>, correlationId?: string }>()
);

export const createWithResource = createAction(
  '[UserResource] Create ProductFaceDefaultPlacement with resource',
  props<{ entity: Entity, file: File, correlationId?: string }>()
);

export const loadPageFailure = createAction(
  '[ProductFaceDefaultPlacement] Load Paginated Entities Failed',
  props<{ error: Error, correlationId?: string }>()
);

export const create = createAction(
  '[ProductFaceDefaultPlacement] Create Entity',
  props<{ entity: Entity, correlationId?: string }>()
);

export const clearStore = createAction(
  '[ProductFaceDefaultPlacement] Clear Store Entity'
);

export const createInStore = createAction(
  '[ProductFaceDefaultPlacement] Create In Store Entity',
  props<{ entity: Entity }>()
);

export const updateInStore = createAction(
  '[ProductFaceDefaultPlacement] Update In Store Entity',
  props<{ entity: Entity }>()
);

export const removeInStore = createAction(
  '[ProductFaceDefaultPlacement] Remove In Store Entity',
  props<{ entity: Entity }>()
);

export const saveStoreChanges = createAction(
  '[ProductFaceDefaultPlacement] Save store changes',
  props<{ correlationId?: string }>()
);

export const saveStoreChangesSuccess = createAction(
  '[ProductFaceDefaultPlacement] Save store changes success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const saveStoreChangesFailure = createAction(
  '[ProductFaceDefaultPlacement] Save store changes failure',
  props<{  error: Error, correlationId?: string }>()
);

export const createSuccess = createAction(
  '[ProductFaceDefaultPlacement] Create Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const createFailure = createAction(
  '[ProductFaceDefaultPlacement] Create Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const createMany = createAction(
  '[ProductFaceDefaultPlacement] Create Many Entities',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManySuccess = createAction(
  '[ProductFaceDefaultPlacement] Create Many Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManyFailure = createAction(
  '[ProductFaceDefaultPlacement] Create Many Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const update = createAction(
  '[ProductFaceDefaultPlacement] Update Entity',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateSuccess = createAction(
  '[ProductFaceDefaultPlacement] Update Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateFailure = createAction(
  '[ProductFaceDefaultPlacement] Update Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const updateMany = createAction(
  '[ProductFaceDefaultPlacement] Update Many Entities',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManySuccess = createAction(
  '[ProductFaceDefaultPlacement] Update Many Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManyFailure = createAction(
  '[ProductFaceDefaultPlacement] Update Many Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const remove = createAction(
  '[ProductFaceDefaultPlacement] Remove Entity',
  props<{ entityId: number, correlationId?: string }>()
);

export const removeSuccess = createAction(
  '[ProductFaceDefaultPlacement] Remove Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const removeFailure = createAction(
  '[ProductFaceDefaultPlacement] Remove Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const deselectEntities = createAction(
  '[ProductFaceDefaultPlacement] Deselect Current Entity'
);

export const setCurrentEntity = createAction(
  '[ProductFaceDefaultPlacement] Set Current Entity',
  props<{ entity: Entity }>()
);

export const setCurrentEntityId = createAction(
  '[ProductFaceDefaultPlacement] Set Current Entity Id',
  props<{ entityId: number }>()
);

export const setPaginationSettings = createAction(
  '[ProductFaceDefaultPlacement] Set Pagination Settings',
  props<{
    page: IPage,
  }>()
);

export const setSortSettings = createAction(
  '[ProductFaceDefaultPlacement] Set Sort Settings',
  props<{ tableSort: ITableSort }>()
);

export const ProductFaceDefaultPlacementActions = {
  loadPage,
  loadPageSuccess,
  loadPageFailure,
  load,
  loadSuccess,
  loadFailure,
  loadSingle,
  loadSingleSuccess,
  loadSingleFailure,
  create,
  createSuccess,
  createFailure,
  createMany,
  createManySuccess,
  createManyFailure,
  update,
  updateSuccess,
  updateFailure,
  updateMany,
  updateManySuccess,
  updateManyFailure,
  remove,
  removeSuccess,
  removeFailure,

  setCurrentEntity,
  setCurrentEntityId,
  deselectEntities,

  setPaginationSettings,
  setSortSettings,

  loadSingleIfNecessary,
  createWithResource,

  createInStore,
  updateInStore,
  removeInStore,
  saveStoreChanges,
  saveStoreChangesSuccess,
  saveStoreChangesFailure,
  clearStore
};
